import { SVGProps, Ref, forwardRef } from 'react';

export const GraduationHatOutlinedSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.8 14.674 0 11.904l16-9.237 16 9.236-4.8 2.772c.106.988.13 1.976.133 2.832-.011 2.092-.14 4.958-1.309 6.68-.526.775-1.793 1.63-3.803 2.792-2.713 1.568-4.46 2.355-6.205 2.36h-.035c-1.743-.006-3.49-.792-6.202-2.36-2.01-1.162-3.277-2.017-3.803-2.792-1.175-1.732-1.3-4.62-1.31-6.715.005-.848.03-1.823.134-2.798m2.304 1.33c-.077 1.53-.072 3.091.154 4.607.159 1.062.413 1.8.704 2.229.186.262.504.465.76.65.535.384 1.27.84 2.258 1.411 2.74 1.584 3.978 2.034 5.007 2.038h.022c1.03-.003 2.267-.452 5.011-2.038.987-.57 1.723-1.027 2.258-1.411.256-.185.574-.387.76-.65.289-.426.543-1.159.701-2.212.23-1.521.234-3.088.157-4.623L16 21.14zM16 18.37 4.8 11.903 16 5.438l11.2 6.465z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
GraduationHatOutlinedSize32Glyph.displayName = 'GraduationHatOutlinedSize32Glyph';
